import React from "react";
import FinancialReportPage from "../Reports/FinancialReportPage";

const ReportPayablePage = () => <FinancialReportPage type="payables" />;

export default ReportPayablePage;
